export default "__VITE_ASSET__CavU$J7P__"